let _options = {
  routerConfig: {
    '/user/wbap-admin-login': 'wbap-admin-login'
  }
}

function config (options) {
  if (options) {
    Object.assign(_options, options)
  }
}

config.current = _options

export default config


// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-main/config.js